import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  font-family: 'Creepster', cursive;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Time = styled.div`
  color: #000000;
  font-size: 80px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 1px;
  line-height: 64px;
  position: absolute;
  text-align: center;
  text-decoration: inherit;
  top: 122px;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #BB0000;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0px;
  padding: 8px 8px 0;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
